import store from '@/store/index.js'
const fParams = () => {
	if (store.state.gSh.shPhone.trim() == '' ||
		store.state.gSh.shServerIp.trim() == '' ||
		store.state.gSh.compName.trim() == '' ||
		store.state.gSh.shMallId.trim() == '' ||
		store.state.gSh.shMallName.trim() == '' ) {
		uni.reLaunch({
			url: '/pages/error/error'
		})
	}
}

export default {
	fParams, // 判断参数是否完整
}


// WEBPACK FOOTER //
// ./src/common/global/routerParams.js